// extracted by mini-css-extract-plugin
export default {"root":"Loader-root-9a1a9c60b4e5bacbc2eeb0a8b7981a27"};